// ClientApp.jsx
import React, {useEffect, lazy, Suspense  } from 'react';
import { Routes, Route,  useLocation,  useNavigate  } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import usePayPalScript from './Utilities/ActivatePaymentProcessor';
import PaymentModal from './Utilities/PaymentModal.jsx';
import PaymentGuard from './Utilities/PaymentGuard.jsx';
import {ProtectedRoute} from './Utilities/ProtectedRoute.jsx';
import { useUserContext } from '../UserContext';
import {usePriceContext} from './Components/Context/PriceContext.js';
import './ClientApp.css';
import Home from './Pages/Home.jsx';
import LoginSignup from './Components/LoginSignup/LoginSignup.jsx';
import AccountType from './Components/LoginSignup/AccountType.jsx';
import PriceCalculator from './Components/PriceCalculator/PriceCalculator.jsx';
import Consultation from './Components/PriceCalculator/Consultation.jsx';
import PricePredictor from './Components/PriceCalculator/PricePredictor.jsx';
import { AtomSpinner } from 'react-epic-spinners';
import ConfirmationPayment from './Components/ConfirmationPayment/ConfirmationPayment.jsx';
import AddServices from './Components/AddServices/AddServices.jsx';
import Upload from './Components/Upload/Upload.jsx';


import Privacy from './Components/Privacy/Privacy.jsx';
import Policies from './Pages/Policies.jsx';
import Blog from './Pages/Blog.jsx';

import AboutUs from './Components/AboutUs/AboutUs.jsx';

import Hook from './Components/Hook/Hook.jsx';
import HookB from './Components/Hook/HookB.jsx';
import HookC from './Components/Hook/HookC.jsx';
import SAT from './Components/SAT/SAT.jsx';
import SAThook from './Components/SAT/SAThook.jsx';
import CGI from './Components/CGI/CGI.jsx';
import SupportServices from './Components/Support/SupportServices.jsx';
//import Dashboard from './Pages/Dashboard.jsx';
import Quiz from './Components/SAT/Quiz.jsx'; 

const ClientApp = () => {
  const sdkLoaded = usePayPalScript();
  const Dashboard = lazy(() => import('./Pages/Dashboard.jsx'));
  const CreatorDashboard = lazy(() => import('./Pages/CreatorDashboard.jsx'));
  const SATDashboard = lazy(() => import('./Pages/SATDashboard.jsx'));
  const Error404 = lazy(() => import('./Components/Error404/Error404.jsx'));


  const { user, email, googleDriveID } = useUserContext();
  const { paymentData,
    setPaymentSuccess, 
    confirmation, setConfirmation,
    redirectOptions, setRedirectOptions,
    redirectDashboard, setRedirectDashboard } =usePriceContext();
  
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const publicRoutes = [
      '/', 
      '/about-us', 
      '/login-signup', 
      '/enter',
      '/articles', 
      '/sat-hook', 
      '/home', 
      '/hook', 
      '/hookb', 
      '/hookc', 
      '/price-calculator',
      '/price-predictor',
      '/schedule-consultation',
      '/add-services',
      '/upload',
      '/confirmation-payment'

    ];
    
    // Guard function as a constant
    const isPublic = (pathname) => publicRoutes.includes(pathname);
    const storedUserEmail = localStorage.getItem('userEmail');
  
    // If the user is unauthenticated and trying to access an unallowed route
    if (!(user || storedUserEmail) && !isPublic(location.pathname)) {
      navigate('/', { replace: true });
    }
  }, [user, navigate, location.pathname]);

  

  const handleCancel = () => {
    console.log('Payment canceled.');
    setPaymentSuccess(false);

   
  };
  const handleSuccess = (details) => {
    console.log('Payment successful:', details);
    setPaymentSuccess(true);
  };
  
  const handleError = (error) => {
    console.error('Payment error:', error);
    setPaymentSuccess(false);
  };
  
  const handleClose = () => {
    setConfirmation(false);
   
    if (redirectOptions) {
      console.log('canceling and going to options');
      navigate('/support-services');
      setRedirectOptions(false); // Reset the flag after redirect
    }else{
      if (redirectDashboard){
        console.log('canceling payment and going to dashboard');
        navigate('/dashboard');
        setRedirectDashboard(false);
      }
    }
    
  };
  


  return (
    <>
      <>
       {sdkLoaded && paymentData && typeof paymentData.numericAmount === 'number' && paymentData.numericAmount > 0 && confirmation ? (
          <PaymentModal
            paymentData={paymentData}
            onClose={handleClose}
            amount={paymentData.amount}
            googleDriveID={googleDriveID}
            email={email}
            onCancel={handleCancel}
            onApprove={handleSuccess}
            onError={handleError}
          />
        ) : (
          <div></div>
          )}
      </>
      <Routes>
        <Route path="/" element={<AccountType />} exact />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/home" element={<Home />} />
        <Route path="/articles" element={<Blog />} />
        <Route path="/hook" element={<Hook />} />
        <Route path="/sat-hook" element={<SAThook />} />

        
        
        <Route path="/login-signup"element={<LoginSignup />}/>
        <Route path="/price-calculator" element={<PriceCalculator />} />
        <Route path="/price-predictor" element={<PricePredictor />} />
        <Route path="/schedule-consultation" element={<Consultation />} />
       
        <Route path="/add-services" element={<AddServices />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="*" element={<Suspense fallback={<div>Loading...</div>}> <Error404 /></Suspense>}/>

        <Route path="/hookb" element={<HookB />} />
        <Route path="/hookc" element={<HookC />} />
        <Route path="/sat" element={<SAT />} />
        <Route path="/cgi" element={<CGI />} />
      
     
        <Route path="/sat-practice" element={<Quiz />} />
        <Route path="/support-services" element={<SupportServices />} />

        
        <Route path="/dashboard" element={
          <ProtectedRoute rolesAllowed={['user']}>
            <Suspense fallback={
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}>
                <div className="spinner-fallback" />
              </div>
            }>
              <Dashboard />
            </Suspense>
          </ProtectedRoute>
        } />



        <Route path="/sat-dashboard" element={
          <ProtectedRoute rolesAllowed={['student']}>
            <Suspense fallback={
              <div className="sat-dashboard-container">
                <div className="loading">
                  <h2>Loading SAT Dashboard...</h2>
                </div>
              </div>
            }>
              <SATDashboard />
            </Suspense>
          </ProtectedRoute>
        } />

        <Route path="/creator-dashboard" element={
          <ProtectedRoute rolesAllowed={['creative']}>
            <Suspense fallback={
              <div className="creator-dashboard-container">
                 <div className="creative-loading">
                <AtomSpinner color="#6a2c7e" size={80} />
              </div>
              </div>
            }>
              <CreatorDashboard />
            </Suspense>
          </ProtectedRoute>
        } />


        <Route path="/confirmation-payment" element={<PaymentGuard><ConfirmationPayment /></PaymentGuard>} />

        

      </Routes>
    </>
  );
};

export default ClientApp;
